import { render, staticRenderFns } from "./InstantForm.vue?vue&type=template&id=a920a174&scoped=true&"
import script from "./InstantForm.vue?vue&type=script&lang=ts&"
export * from "./InstantForm.vue?vue&type=script&lang=ts&"
import style0 from "./InstantForm.vue?vue&type=style&index=0&id=a920a174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a920a174",
  null
  
)

export default component.exports